import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { NavButton } from 'components/Button'

const ProductDeleteCompleteTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/delete.svg'} alt={'出品する商品の削除が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          出品する商品の削除が
          <br />
          完了しました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'sacriで出品する商品の一覧に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/product'} />
      <Spacer size={72} />
    </div>
  )
}

export default ProductDeleteCompleteTemplate
